export default __webpack_public_path__ + "static/media/heat-map.4febc11b.svg";